import { createAction, props } from '@ngrx/store';

enum PaymentMachineActionType {
    LOAD_PAYMENT_MACHINE = '[payment_machine] load payment_machine from api',
    LOAD_PAYMENT_MACHINE_SUCCESS = '[payment_machine] load payment_machine from api return success',
    LOAD_PAYMENT_MACHINE_ERROR = '[payment_machine] load payment_machine from api return error',

    SAVE_PAYMENT_MACHINE = '[payment_machine] save payment_machine from api',
    SAVE_PAYMENT_MACHINE_SUCCESS = '[payment_machine] save payment_machine from api return success',

    EDIT_PAYMENT_MACHINE = '[payment_machine] edit payment_machine from api',
    EDIT_PAYMENT_MACHINE_SUCCESS = '[payment_machine] edit payment_machine from api',

    DELETE_PAYMENT_MACHINE = "[payment_machine] delete payment_machine from api"

}

const loadPaymentMachine = createAction(
    PaymentMachineActionType.LOAD_PAYMENT_MACHINE
);

const loadPaymentMachineSuccess = createAction(
    PaymentMachineActionType.LOAD_PAYMENT_MACHINE_SUCCESS, props<{ lista: any[] }>()
);

const savePaymentMachine = createAction(
    PaymentMachineActionType.SAVE_PAYMENT_MACHINE, props<{ machine: any }>()
)

const savePaymentMachineSuccess = createAction(
    PaymentMachineActionType.SAVE_PAYMENT_MACHINE_SUCCESS, props<{ machine: any }>()
)

const editPaymentMachine = createAction(
    PaymentMachineActionType.EDIT_PAYMENT_MACHINE, props<{ machine: any, id: any }>()
)

const editPaymentMachineSuccess = createAction(
    PaymentMachineActionType.EDIT_PAYMENT_MACHINE_SUCCESS,
    props<{ machine: any }>()
);

const deletePaymentMachine = createAction(
    PaymentMachineActionType.DELETE_PAYMENT_MACHINE,
    props<{ id: number }>()
)

export const paymentMachineActions = {
    loadPaymentMachine,
    loadPaymentMachineSuccess,
    savePaymentMachine,
    savePaymentMachineSuccess,
    deletePaymentMachine,
    editPaymentMachine,
    editPaymentMachineSuccess
}